import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { academylist, leaveapply, leavedetail } from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import moment from "moment";

export default function Applyleave() {
  const { id } = useParams();
  const [ltype, setLType] = useState("");
  const [ptype, setPType] = useState("");
  const [ldays, setLDays] = useState("");
  const [fdate, setFDate] = useState("");
  const [tdate, setTDate] = useState("");
  const [lreason, setLReason] = useState("");

  const [lsubmit, setLSubmit] = useState(false);
  const navigate = useNavigate();

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
    } else {
      setAcaID("");
    }
  }
  const [loading, setLoading] = useState(false);
  const [urllink, setUrl] = useState("");
  const location = useLocation();
  useEffect(() => {

    if (localStorage.getItem("ADate") !== '') {
      setFDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      setTDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    } else {
      setFDate(moment(new Date()).format("YYYY-MM-DD"));
      setTDate(moment(new Date()).format("YYYY-MM-DD"));
    }
    const path = location.pathname.split("/")[2]; // Extracts 'allstudent' or 'leftstudentlist'
    setUrl(path);
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (path === "leavedetail") {
      leavedetail(id).then((response) => {
        if (response.status === true && response.data.details) {
          setLType(response.data.details.leave_permission);
          setPType(response.data.details.leave_type);
          setLDays(response.data.details.total_leave);
          setFDate(response.data.details.from_date);
          setTDate(response.data.details.to_date);
          setLReason(response.data.details.reason);
          academylist().then((res) => {
            if (res.status === true) {
              let arr = [];
              if (res.data.details.length > 0) {
                for (let i = 0; i < res.data.details.length; i++) {
                  if (
                    res.data.details[i].id === response.data.details.academy_id
                  ) {
                    arr.push({
                      value: res.data.details[i].id,
                      label:
                        res.data.details[i].name +
                        " - " +
                        res.data.details[i].code,
                    });
                  }
                }
                setAcaID(arr[0]);
              }
            }
          });
        }
      });
    } else {
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);

                }
              }

            }
          }
        });
      }
    }
  }, []);

  const [errormsg, setErrMsg] = useState("");

  function leavesubmit(e) {
    e.preventDefault();
    setLSubmit(true);
    if (
      ltype !== "" &&
      ptype !== "" &&
      ldays !== "" &&
      fdate !== "" &&
      tdate !== "" &&
      lreason !== ""
    ) {
      let valid = "";
      if (localStorage.getItem("Role") === "1") {
        if (acaid === "") {
          setErrMsg("Please Select Academy");
          valid = "Please Select Academy";
        }
      }
      if (valid === "") {
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        temp.append("leave_permission", ltype);
        temp.append("leave_type", ptype);
        temp.append("total_leave", ldays);
        temp.append("from_date", fdate);
        temp.append("to_date", tdate);
        temp.append("reason", lreason);
        if (urllink === "leavedetail") {
          temp.append("id", id);
        }
        leaveapply(temp).then((res) => {
          if (res.status === true) {
            setLSubmit(false);
            toast.success(res.message);
            navigate("/leavemanagement/allleave");
          } else {
            setErrMsg(res.message);
          }
        });
      }
    }
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{urllink === "leavedetail" ? "Leave Detail" : "Apply Leave"}</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Leave Management</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "leavedetail" ? "Leave Detail" : "Apply Leave"}
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card mb-4">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">
                {urllink === "leavedetail" ? "Leave Detail" : "Apply Leave"}
              </h2>
            </div>
            <div className="card-body">
              <div className="row">
                {localStorage.getItem("Role") === "1" && (
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Select Academy <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="default-select"
                        placeholder="Select Academy"
                        value={acaid}
                        options={aclist}
                        onChange={handleAcademy}
                        isSearchable={true}
                        isClearable
                        hidden
                      />
                      {lsubmit && acaid === "" && (
                        <span className="text-danger">
                          Please Select Academy
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Type<span className="text-danger"> *</span>
                    </label>
                    <select
                      className="default-select form-control wide"
                      onChange={(e) => setLType(e.target.value)}
                      value={ltype}
                    >
                      <option value="" disabled>
                        Select Type
                      </option>
                      <option value="Leave">Leave</option>
                      <option value="Permission">Permission</option>
                    </select>
                    {lsubmit && ltype === "" && (
                      <span className="text-danger">Please Select Type</span>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Leave/Permission Type
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      className="default-select form-control wide"
                      onChange={(e) => setPType(e.target.value)}
                      value={ptype}
                    >
                      <option value="" disabled>
                        Select Leave/Permission Type
                      </option>
                      <option value="Sick">Sick</option>
                      <option value="Casual">Casual</option>
                      <option value="Personal">Personal</option>
                    </select>
                    {lsubmit && ptype === "" && (
                      <span className="text-danger">
                        Please Select Leave/Permission Type
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Total Leave Days/Permission (In Hrs)
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Total Leave Days/Permission (In Hrs)"
                      onChange={(e) => setLDays(e.target.value)}
                      value={ldays}
                    />
                    {lsubmit && ldays === "" && (
                      <span className="text-danger">
                        Please Enter Total Leave Days/Permission (In Hrs)
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      From Date<span className="text-danger"> *</span>
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      onChange={(e) => setFDate(e.target.value)}
                      value={fdate}
                    />
                    {lsubmit && fdate === "" && (
                      <span className="text-danger">
                        Please Enter From Date
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      To Date<span className="text-danger"> *</span>
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      onChange={(e) => setTDate(e.target.value)}
                      value={tdate}
                    />
                    {lsubmit && tdate === "" && (
                      <span className="text-danger">Please Enter To Date</span>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Reason<span className="text-danger"> *</span>
                    </label>
                    <textarea
                      className="form-control"
                      name="example-textarea-input"
                      rows={4}
                      placeholder="Enter Reason"
                      onChange={(e) => setLReason(e.target.value)}
                      value={lreason}
                    />
                    {lsubmit && lreason === "" && (
                      <span className="text-danger">Please Enter Reason</span>
                    )}
                  </div>
                </div>
                
              </div>
              <div className="res-right mt-2 me-4">
                  <button className="btn btn-success me-2" onClick={leavesubmit}>
                    Submit
                  </button>

                  {id !== undefined && (
                    <button
                      className="btn btn-secondary"
                      onClick={() => navigate("/leavemanagement/allleave")}
                    >
                      Back
                    </button>
                  )}
                </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  );
}
